<div class="p-3 border rounded-3 bg-light shadow">
  <div class="mb-3 d-flex align-items-center">
    @if (!!sellerProfileImageUrl) {
      <div class="profile-image">
        <nz-image [imageUrl]="sellerProfileImageUrl"/>
      </div>
    } @else {
      <i class="pe-3 fa-2x fa-solid fa-user text-muted"></i>
    }
    <div class="ps-3"
         [class.border-start]="!sellerProfileImageUrl">
      <a class="fs-5 btn-link text-break text-decoration-none"
         [routerLink]="[appRoutes.root, appRoutes.profile, adDetails.sellerId]">
        {{ adDetails.sellerUsername }}
      </a>
      <div class="text-muted small">
        В Collectoria от {{ adDetails.sellerRegistrationDate | date:'dd.MM.yyyy г.' }}
      </div>
    </div>
  </div>
  <div class="small d-flex flex-wrap gap-2">
    <span>Потребителски рейтинг:</span>
    <div class="text-nowrap d-flex">
      <nz-user-rating [rating]="adDetails.sellerRating"/>
      <button
        type="button"
        aria-label="Научете повече"
        (click)="showUserRatingInfo()"
        class="ms-1 p-0 btn btn-link btn-sm text-primary-emphasis">
        <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <hr class="my-3">
  <a class="text-decoration-none"
     [queryParams]="{sellerId: adDetails.sellerId, sellerUsername: adDetails.sellerUsername}"
     [routerLink]="[appRoutes.root, appRoutes.adList]">
    Активни обяви: {{ adDetails.sellerAdCount }}
  </a>
</div>
